import React from "react";
import SlidePanel from "../add_customer/SlidePanel";
import { X } from "lucide-react";

const PaymentNotReceived = ({
  id,
  isPaymentNotReceived,
  handleCancelTransaction,
  handleEditPayment,
  handleRetryPayment,
}) => {
  return (
    <SlidePanel isOpen={isPaymentNotReceived} onClose={handleCancelTransaction}>
      <div className="relative flex flex-col h-full bg-white rounded-[12px]">
        {/* Close Button */}
        <div
          onClick={handleCancelTransaction}
          className="absolute top-0 right-0 cursor-pointer h-[40px] w-[40px] bg-[#FF0000] rounded-tr-[10px] rounded-bl-[20px] flex items-center justify-center z-10"
        >
          <X color="#ffffff" />
        </div>

        <div className="flex flex-col h-full px-8 mt-8">
          {/* Error Banner */}
          <div className="mt-10 bg-[#FF5757] rounded-lg p-3 text-center">
            <p className="text-white text-[14px] mt-1">
              Sorry, we did not receive payment.
            </p>
          </div>

          {/* MPESA SMS */}
          <div className="text-center px-5 mt-5">
            <p className="text-[#060606] text-[13px] leading-6">
              You can initiate the payment process again by pressing <br /> the
              <span className="font-medium"> "Try Again" </span>
              button below.
            </p>
          </div>

          <div className="flex-1 overflow-y-auto pb-2 flex flex-col gap-3">
            {/* Sad Face */}
            <div className="flex justify-center mt-5">
              <svg
                width="140"
                height="140"
                viewBox="0 0 140 140"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="70" cy="70" r="70" fill="#FFCB35" />

                <circle cx="50" cy="52" r="8" fill="white" />
                <circle cx="90" cy="52" r="8" fill="white" />

                <path
                  d="M42 100C50 88 90 88 98 100"
                  stroke="white"
                  strokeWidth="10"
                  strokeLinecap="round"
                />
              </svg>
            </div>

            {/* Title */}
            <h2 className="text-center text-[16px] font-bold text-[#060606] mt-3">
              Payment Not Received
            </h2>

            {/* Ensure Section */}
            <div className="mt-3">
              <p className="text-[#074073] text-[12px] font-medium">
                Ensure that:
              </p>

              <div className="space-y-2">
                <div className="flex items-start gap-3">
                  <span className="text-[#16A34A] text-[18px] leading-none mt-[2px]">
                    ✔
                  </span>
                  <p className="text-[14px] text-[#060606]">
                    Your M-Pesa SIM is active.
                  </p>
                </div>

                <div className="flex items-start gap-3">
                  <span className="text-[#16A34A] text-[18px] leading-none mt-[2px]">
                    ✔
                  </span>
                  <p className="text-[14px] text-[#060606]">
                    You entered your correct M-PESA PIN to authorise
                    transaction.
                  </p>
                </div>

                <div className="flex items-start gap-3">
                  <span className="text-[#16A34A] text-[18px] leading-none mt-[2px]">
                    ✔
                  </span>
                  <p className="text-[14px] text-[#060606]">
                    You did not cancel the M-PESA prompt.
                  </p>
                </div>
              </div>
            </div>

            {/* Description */}
          </div>

          {/* Try Again */}
          <div className="pb-5 space-y-3">
            <button
              onClick={handleRetryPayment}
              className="w-full py-2.5 border border-[#074073] bg-[#074073] text-white rounded-lg text-[#074073] text-[14px] font-medium  transition-colors"
            >
              Try Again
            </button>

            <button
              onClick={handleEditPayment}
              className="w-full py-2.5 border border-[#074073] rounded-lg text-[#074073] text-[14px] font-medium"
            >
              Edit Payment
            </button>
          </div>
        </div>
      </div>
    </SlidePanel>
  );
};

export default PaymentNotReceived;
